import React, { useState, useMemo, useEffect, useRef } from 'react';
import FileSaver from "file-saver";
import { CallApiGet, CallApiPost, NewCall } from '../../apicalls/calls';
import { DataSheetGrid, textColumn, keyColumn, floatColumn, createTextColumn } from 'react-datasheet-grid';
import { useSelector, useDispatch } from 'react-redux';
import { selectTalonera, setTalonera } from '../../slice/global.js';
import { useParams } from 'react-router-dom';
import Security from '../Security/Security';
import RegistrosModal from '../Sorteo/RegistrosModal';
import convertFromBase64 from "../../helpers/convertFromBase64";
import Comprobantes from './Comprobantes';

export default function CapturaNueva(props) {
    const { IsEspecial } = props;
    const [deuda, setDeuda] = useState(false);
    const [cMaxima, setCMaxima] = useState(0);
    const [hasErrorCaptura, setHasErrorCaptura] = useState(true);
    const inputElementCmax = useRef();
    const [allowed, setAllowed] = useState(true);
    const Normal = [2, 3];
    const Admin = [1, 4];
    const UsuarioS = JSON.parse(window.localStorage.getItem('usuario'));
    const TablaTalonera = useSelector(selectTalonera);
    const { id_sorteo } = useParams();
    const dispatch = useDispatch();
    const [Tabla1, setTabla1] = useState(TablaTalonera.tabla1);
    const [Tabla2, setTabla2] = useState(TablaTalonera.tabla2);
    const [tiposorteo, SettipoSorteo] = useState(true);
    const [deudaC, setDeudaC] = useState(false);
    const [totalSum, SettotalSum] = useState({
        TotalCompleto: 0,
        Totaltabla1: 0,
        Totaltabla2: 0
    });
    // const [files, setFiles] = useState([]);
    //Creamos la referencia del datagrid
    const ref = useRef(null);
    const [cell, setActive] = useState({});
    const [cliente, setCliente] = useState("");

    //Solo para el usuario 4
    const [coperativas, SetCoperativas] = useState([]);
    const [corredores, Setcorredores] = useState([]);


    const createdRowIds = useMemo(() => new Set(), [])
    const deletedRowIds = useMemo(() => new Set(), [])
    const updatedRowIds = useMemo(() => new Set(), [])
    const testMaxC = useMemo(() => cMaxima);
    const Tabla1Memo = useMemo(() => Tabla1);
    const Tabla2Memo = useMemo(() => Tabla2);


    const commit = () => {

        createdRowIds.clear()
        deletedRowIds.clear()
        updatedRowIds.clear()
    }


    const columns = [
        {
            ...keyColumn('numero', createTextColumn({
                parseUserInput: (value) => {
                    //console.log('example', value);
                    return value.replace(/\D/g, "").substring(0, 3);
                },
                parsePastedValue: (value) => {
                    //console.log('example', value);
                    return value.replace(/\D/g, "").substring(0, 3);
                },
            })),
            title: 'Numero',
            //width:'0 0 50px',
            minWidth: 70,
            maxWidth: 100
        },
        {
            ...keyColumn('cantidad', createTextColumn({
                parseUserInput: (value) => {
                    console.log("current", ref.current);
                    var numsStr = value.replace(/\D/g, '');
                    return numsStr != '' && numsStr != "0" ? parseInt(numsStr) : '';
                },
                parsePastedValue: (value) => {
                    var numsStr = value.replace(/\D/g, '');
                    return numsStr != '' && numsStr != "0" ? parseInt(numsStr) : '';
                },
            })),
            title: 'Cantidad',
            //width:'0 0 50px',
            minWidth: 70,
            maxWidth: 100
        },
        /*  {
             ...keyColumn('cantidad', floatColumn),
             title: 'Cantidad',
             minWidth: 70,
             maxWidth: 100
         }, */
        {
            ...keyColumn('referencia', textColumn),
            title: 'Referencia',
        },
    ];

    useEffect(() => {
        GetTotal();
    }, [Tabla1, Tabla2]);



    /*async function fetchData() {
        $("#backdrop").show();
        var params = { id_usuario: $("#selectedU").val(), id_sorteo: id_sorteo, captura_por: UsuarioS.user.id };
        const Call = await CallApiGet(`getTalonera`, params, UsuarioS.access_token);
        setCMaxima(Call.success.sorteos.cantidad_maxima)
        setDeuda(Call.success.sorteos.deuda);
        dispatch(setTalonera(Call.success.sorteos));
        await getCoperativas();
        $("#backdrop").hide();
    }*/

    function fetchData() {
        $("#backdrop").show();
        var params = { id_usuario: $("#selectedU").val(), id_sorteo: id_sorteo, captura_por: UsuarioS.user.id };
        CallApiGet(`getTalonera`, params, UsuarioS.access_token).then((e) => {
            setCMaxima(e.success.sorteos.cantidad_maxima)
            setDeuda(e.success.sorteos.deuda);
            dispatch(setTalonera(e.success.sorteos));
            $("#backdrop").hide();
        });

        var params = { tipo: 1 };
        CallApiGet(`getUsuariosCaptura`, params, UsuarioS.access_token).then((e) => {
            SetCoperativas(e.success.sorteos);
        });
        
        //getCoperativas();
        //$("#backdrop").hide();
    }

    function getCoperativas() {
        var params = { tipo: 1 };
        CallApiGet(`getUsuariosCaptura`, params, UsuarioS.access_token).then((e) => {
            SetCoperativas(e.success.sorteos);
        });
       
    }


    function ChangeTipo(e) {
        e.stopPropagation();
        if (TablaTalonera.sorteo.multiple == 1) {
            window.Swal.fire({
                title: `¿Está seguro de cambiar al sorteo del ${tiposorteo ? 'segundo' : 'primer'} lugar?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    SettipoSorteo(!tiposorteo);
                }

            });
        }
    }

    async function SaveData() {
        $("#backdrop").show();

        if (UsuarioS.user.tipo_usuario == 4) {
            if ($("#selectedCop").val() == '') {
                window.Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: "Seleccione una coperativa",
                });
                $("#backdrop").hide();
                return;
            }
        }


        /* if (testMaxC > 0) {
            if (CheckNumSatura(Tabla1)) {
                window.Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: "Hay registros con cantidad incorrecta en el primer lugar",
                });
                $("#backdrop").hide();
                return;
            }

            if (CheckNumSatura(Tabla2)) {
                window.Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: "Hay registros con cantidad incorrecta en el segundo lugar",
                });
                $("#backdrop").hide();
                return;
            }
        } */

        /*  if (CheckAllCaptures()) {
             window.Swal.fire({
                 icon: 'error',
                 title: 'Error',
                 text: "Hay registros con cantidad incorrecta",
             });
             $("#backdrop").hide();
             return;
         } */




        var NewData = {};
        {
            Normal.includes(UsuarioS.user.tipo_usuario) ?
                NewData = {
                    usuario_id: $("#selectedU").val(),
                    sorteo_id: id_sorteo,
                    captura_por: UsuarioS.user.id,
                    tabla1: Tabla1,
                    tabla2: Tabla2,
                    cliente,

                    especial: IsEspecial,
                    loggedUser: UsuarioS.user.id,
                    loggedUserTipo: UsuarioS.user.tipo_usuario
                } :
                NewData = {
                    usuario_id: $("#selectedCor").val() == '' ? $("#selectedCop").val() : $("#selectedCor").val(),
                    sorteo_id: id_sorteo,
                    captura_por: $("#selectedCor").val() == '' ? $("#selectedCop").val() : $("#selectedCor").val(),
                    tabla1: Tabla1,
                    tabla2: Tabla2,
                    cliente,

                    especial: IsEspecial,
                    loggedUser: UsuarioS.user.id,
                    loggedUserTipo: UsuarioS.user.tipo_usuario
                }
        }

        const resp = await CallApiPost('saveCapturaTabla', NewData, UsuarioS.access_token);
        if (resp.status != 200) {
            window.Swal.fire({
                html: resp.error.message,
                icon: 'error',
                title: 'Error',
                //text: resp.error.message,
            });
            $("#backdrop").hide();
        } else {
            const folio = resp.success.captura.folio ?? "";
            commit();
            setTabla1([]);
            setTabla2([]);
            GetTotal();
            await fetchData();
            $("#backdrop").hide();
            if (resp.success.message_error.length) {
                await window.Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: resp.success.message_error.join("</br>"),
                });
            }

            if (folio) {
                await window.Swal.fire({
                    title: `¿Desea descargar los archivos?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        $("#backdrop").show();
                        //console.log(folio)
                        const resp = await CallApiGet('getTicketV2/' + folio, "", UsuarioS.access_token);
                        const tickets = resp.success.data.tickets ?? [];
                        tickets.forEach(t => {
                            FileSaver.saveAs(convertFromBase64(t.stream));
                        });
                        $("#backdrop").hide();
                    }
                });
            }
        }
        setCliente("");
    }

    function NewRow() {
        var newElment = { id: `${Date.now()}_nuevo`, numero: null, cantidad: null, referencia: null, tipo: tiposorteo ? 1 : 2 };
        createdRowIds.add(newElment.id);
        tiposorteo ? setTabla1([...Tabla1, newElment]) : setTabla2([...Tabla2, newElment]);
    }

    function ChangeUser() {
        fetchData();
    }

    function GetTotal() {
        //console.log("setTotal");
        let ArraySum = Tabla1.concat(Tabla2);
        SettotalSum(
            {
                TotalCompleto: sumArrays(ArraySum),
                Totaltabla1: sumArrays(Tabla1),
                Totaltabla2: sumArrays(Tabla2)
            }
        );
    }

    function sumArrays(array) {
        let sum = 0;
        var t1 = array.forEach(element => {
            if (!isNaN(element.cantidad) && element.cantidad != null && element.cantidad != '') {
                sum += parseInt(element.cantidad);
            }
        });
        return sum;
    }

    async function changeCoperativa() {
        $("#backdrop").show();
        let selected = $("#selectedCop").val();
        if (selected != "TODAS") {
            var params = { tipo: 2, usuario: selected };
            const Call = await CallApiGet(`getUsuariosCaptura`, params, UsuarioS.access_token);
            Setcorredores(Call.success.sorteos);
            setDeudaC(Call.success.deuda);
        } else {
            setDeudaC(false);
        }
        $("#backdrop").hide();
    }

    const openComprobantesModal = () => $('#comprobantes').modal('show');

    const openRegistrosModal = () => $('#registros').modal('show');

    const closeRegistrosModal = () => $('#registros').modal('hide');

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        (() => {
            if (UsuarioS.user.tipo_usuario == 1 || !deuda) {
                setAllowed(true);
            }
            else {
                setAllowed(false);
            }
        })();
    }, [deuda]);

    const CheckRow = (cantidad) => {
        //let valor = parseFloat(inputElementCmax.current.value);
        let valor = testMaxC;
        let rValor = cantidad == 0 || cantidad == null ? true : false;
        return rValor;
    }

    const VerifyCantidad = (dta) => {
        return dta.find((elm) => elm.cantidad == 0) != undefined ? false : true;
    }

    const CheckAllCaptures = () => {
        let r = false;
        Tabla1.forEach((elm) => {
            //console.log("t1", elm);
            if (elm.cantidad == 0 /* || elm.cantidad == null */) {
                return r = true;
            }
        });
        Tabla2.forEach((elm) => {
            //console.log("t2", elm);
            if (elm.cantidad == 0 /* || elm.cantidad == null */) {
                return r = true;
            }
        });
        return r;
    }

    const CheckCantNum = (dta, num, tipo) => {
        let SumT = 0;
        //let completeR = dta.concat(!tiposorteo ? Tabla1Memo : Tabla2Memo);
        let completeR = dta;
        //console.log("completer", completeR);
        let filterElm = completeR.filter((elm) => elm.numero == num);
        //console.log("filter", filterElm);
        if (filterElm.length > 0) {
            SumT = filterElm.reduce((a, b) => a + b.cantidad, 0);
            //console.log("sum", SumT);
        }
        return SumT;
    }

    const CheckNumSatura = (arr) => {
        //console.log(testMaxC)
        let res = Object.values(arr.reduce((acc, curr) => {
            (acc[curr.numero] = acc[curr.numero] || { numero: curr.numero, cantidad: 0 }).cantidad += curr.cantidad != '' ? curr.cantidad : 0;
            //console.log("current", curr.cantidad)
            return acc;
        }, {}));
        let filterElm = res.filter((elm) => parseInt(elm.cantidad) > testMaxC);
        //console.log("array", arr);
        //console.log("CantidadSum", res);
        //console.log("validaton", filterElm);
        return filterElm.length ? true : false;
    }

    const AcumNumTabla = (arr) => {
        let copy = arr;
        let returnA = [];
        let Ref = [];
        arr.forEach((elm, idx) => {
            if (elm.numero != null)
                elm.numero.replace(/\D/g, "").substring(0, 3);

            if (testMaxC > 0) {
                if (elm.numero != null || elm.numero != "") {
                    let reduce = copy.slice(0, (idx + 1));
                    let filterElm = reduce.filter((felm) => felm.numero == elm.numero);
                    if (filterElm.length == 0)
                        //var numsStr = elm.cantidad.replace(/\D/g, '');
                        //elm.cantidad = numsStr != '' && numsStr != "0" && numsStr!=undefined ? parseInt(numsStr) : '';
                        returnA.push(elm);
                    if (filterElm.length > 0) {
                        let SumT = filterElm.reduce((a, b) => a + b.cantidad, 0);
                        //if (SumT == 0)
                        //returnA.push(elm);
                        if (SumT <= testMaxC) {
                            //var numsStr = elm.cantidad.replace(/\D/g, '');
                            //elm.cantidad = numsStr != '' && numsStr != "0" && numsStr!=undefined ? parseInt(numsStr) : '';
                            returnA.push(elm);
                        }
                        else {

                            elm.cantidad = '';
                            returnA.push(elm);
                        }
                    }
                } else {
                    returnA.push(elm);
                }
            } else {
                returnA.push(elm);
            }
            //console.log("reduce"+idx,reduce);
        });

        return returnA;
        //arr.map((elm) => res[elm.numero].cantidad > testMaxC )
    }

    const CheckInputCapture = async ($numero, $cantidad) => {
        var params = { numero: $numero, cantidad: $cantidad, sorteo_id: id_sorteo, tipo: tiposorteo };
        const resp = await CallApiPost('validateSR', params, UsuarioS.access_token);
        //console.log("status",resp.status);
        return resp;
    }

    return (
        <Security condition={allowed} redirectTo="/">
            {/* <button onClick={() => console.log("table", Tabla1)}> checkstarte</button> */}
            {/*  <button onClick={() => AcumNumTabla(Tabla1)}>testvalidation</button> */}
            {/* <input type="hidden" id='cmax' value={cMaxima} ref={inputElementCmax} onChange={() => ''} /> */}
            <div className="modal fade" id="registros" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl" style={{ maxWidth: "80vw" }} role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Mis capturas</h5>
                            <button type="button" onClick={closeRegistrosModal} className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <RegistrosModal id_sorteo={id_sorteo} UsuarioS={UsuarioS} is_captura={true} />
                        </div>
                        <div className="modal-footer">
                            <button type="button" onClick={closeRegistrosModal} className="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
            <Comprobantes />
            <div className='container-fluid'>
                {deudaC && (
                    <div className="row">
                        <div className='col-sm-12 col-md-12 col-lg-12'>
                            <div className="alert alert-danger" style={{ fontSize: "16px" }} role="alert">
                                La cooperativa seleccionada tiene deuda pendiente
                            </div>
                        </div>
                    </div>
                )}
                {/* {
                    cMaxima > 0 &&
                    <div className="row">
                        <div className='col-sm-12 col-md-12 col-xl-12'>
                            <div className="alert alert-danger" style={{ fontSize: "16px" }} role="alert">
                                La cantidad máxima de captura por número es : ${cMaxima}
                            </div>
                        </div>
                    </div>
                } */}
                <div className='row' style={{ paddingBottom: '20px' }}>
                    {Normal.includes(UsuarioS.user.tipo_usuario) && (
                        <>
                            {UsuarioS.user.tipo_usuario < 3 && (
                                <>
                                    <div className='col-sm-3 col-md-3 col-lg-3'>
                                        <select name="selectedU" id="selectedU" className='form-select form-select-sm mx-2 mt-2' onChange={() => ChangeUser()}>
                                            <option value={UsuarioS.user.id}>Seleccione un usuario</option>
                                            {TablaTalonera.usuarios && TablaTalonera.usuarios.map((element, key) => (
                                                <option value={element.id} key={key}>{element.nombre}</option>
                                            ))}
                                        </select>
                                    </div>
                                    {/* <div className='col-sm-3 col-md-3 col-lg-3'>
                                        <input type="text" name='cliente' id="cliente" className='form-control form-control-sm mx-2 mt-2' value={cliente} onChange={e => setCliente(e.target.value)} placeholder="Referencia cliente" />
                                    </div> */}
                                </>
                            )}
                            <div className='col-sm-3 col-md-3 col-lg-3'>
                                <input type="text" name='cliente' id="cliente" className='form-control form-control-sm mx-2 mt-2' value={cliente} onChange={e => setCliente(e.target.value)} placeholder="Referencia cliente" />
                            </div>
                            <div className={UsuarioS.user.tipo_usuario < 3 ? `col-sm-6 col-md-6 col-lg-6 text-right` : "col-sm-9 col-md-9 col-lg-9 text-right"}>
                                {UsuarioS.user.tipo_usuario == 3 && (<input type="hidden" id="selectedU" value={UsuarioS.user.id} />)}
                                <button type="button" onClick={openRegistrosModal} className={`btn btn-sm mx-2 mt-2 btn-${tiposorteo ? 'primary' : 'success'}`}>
                                    Mis capturas
                                </button>
                                <button type="button" onClick={openComprobantesModal} className={`btn btn-sm mx-2 mt-2 btn-${tiposorteo ? 'primary' : 'success'}`}>
                                    Mis comprobantes
                                </button>
                                <button className={`btn btn-sm mx-2 mt-2 btn-${tiposorteo ? 'primary' : 'success'}`} onClick={() => NewRow()}>Nueva fila</button>
                                <button className='btn btn-sm btn-secondary mx-2 mt-2' onClick={() => SaveData()}>
                                    Guardar
                                </button>
                            </div>
                        </>
                    )}
                    {Admin.includes(UsuarioS.user.tipo_usuario) && (
                        <div className='row'>
                            <div className='col-sm-4 col-md-4 col-lg-4'>
                                <select name="selectedCop" id="selectedCop" className='form-select form-select-sm mx-2 mt-2' onChange={() => changeCoperativa()}>
                                    <option value={UsuarioS.user.tipo_usuario == 1 ? UsuarioS.user.id : ''}>Seleccione una coperativa</option>
                                    {coperativas && coperativas.map((item, key) => (
                                        <option value={item.id} key={key}>{item.nombre}</option>
                                    ))}
                                </select>
                            </div>
                            <div className='col-sm-4 col-md-4 col-lg-4'>
                                <select name="selectedCor" id="selectedCor" className='form-select form-select-sm mx-2 mt-2'>
                                    <option value={""}>Seleccione un corredor</option>
                                    {corredores && corredores.map((item, key) => (
                                        <option value={item.id} key={key}>{item.nombre}</option>
                                    ))}
                                </select>
                            </div>
                            <div className='col-sm-4 col-md-4 col-lg-4'>
                                <input type="text" name='cliente' id="cliente" className='form-control form-control-sm mx-2 mt-2' value={cliente} onChange={e => setCliente(e.target.value)} placeholder="Referencia cliente" />
                            </div>
                            <div className={"col-sm-12 col-md-12 col-lg-12 text-right"}>
                                <button type="button" onClick={openRegistrosModal} className={`btn btn-sm mx-2 mt-2 btn-${tiposorteo ? 'primary' : 'success'}`}>
                                    Mis capturas
                                </button>
                                <button type="button" onClick={openComprobantesModal} className={`btn btn-sm mx-2 mt-2 btn-${tiposorteo ? 'primary' : 'success'}`}>
                                    Mis comprobantes
                                </button>
                                <button className={`btn btn-sm mx-2 mt-2 btn-${tiposorteo ? 'primary' : 'success'}`} onClick={() => NewRow()}>Nueva fila</button>
                                {!deudaC && (
                                    <button className='btn btn-sm btn-secondary mx-2 mt-2' onClick={() => SaveData()}>
                                        Guardar
                                    </button>
                                )}
                                {deudaC && (
                                    <button className='btn btn-sm btn-secondary mx-2 mt-2' disabled>
                                        Guardar
                                    </button>
                                )}
                            </div>
                        </div>
                    )}
                </div>

                <div className='row'>
                    <div className='col-sm-12 col-md-12 col-lg-12'>
                        <div className="card shadow mb-4">
                            <div className={`card-header py-3 ${tiposorteo ? 'bg-gradient-primary' : 'bg-gradient-success'}`} onClick={(e) => ChangeTipo(e)} style={{ cursor: 'pointer' }} >
                                <div className='row'>
                                    <div className='col-6'>
                                        <h6 className="m-0 font-weight-bold text-white ">{TablaTalonera.sorteo.nombre}: {tiposorteo ? 'Primer Lugar' : 'Segundo Lugar'}</h6>
                                    </div>
                                    <div className='col-6 text-right text-white'>
                                        <i className="fa fa-arrow-circle-left fa-lg" aria-hidden="true"></i>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <em><i className="fa fa-info-circle" aria-hidden="true"></i> Nota: La información en la captura solo se registrará al momento de realizar la acción de "Guardar".</em>
                                <DataSheetGrid
                                    ref={ref}
                                    value={tiposorteo ? Tabla1 : Tabla2}
                                    onBlur={(cell) => {
                                        /* console.log("cell",cell);
                                        if(cell.cell.colId=="numero")
                                            console.log("fila",Tabla1) */
                                        //console.log(UsuarioS.user.tipo)
                                        //validacion de captura a la derecha, horizontal
                                        /* if (UsuarioS.user.tipo_usuario == 3) {
                                            if (cell.cell.col == 2) {
                                                ref.current?.setActiveCell({ col: 0, row: cell.cell.row + 1 })
                                            } else {
                                                ref.current?.setActiveCell({ col: cell.cell.col + 1, row: cell.cell.row })
                                            }
                                        } */

                                    }}
                                    autoAddRow
                                    createRow={() => ({ id: Date.now(), numero: null, cantidad: null, referencia: null })}
                                    onChange={async (newValue, operations) => {
                                        //newValue=AcumNumTabla(newValue);
                                        //newValue = []
                                        //console.log("operaciones", operations)
                                        for (const operation of operations) {
                                            if (operation.type === 'CREATE') {
                                                //console.log("dtaCreate", newValue)
                                                newValue.slice(operation.fromRowIndex, operation.toRowIndex).forEach(({ id }) => createdRowIds.add(id));
                                                let numC = newValue.slice(operation.fromRowIndex, operation.toRowIndex).length;
                                                //if(numC>0)

                                                //console.log("TestRandom", AcumNumTabla(newValue))
                                                //console.log("error", AcumNumTabla(newValue))
                                                //newValue = AcumNumTabla(newValue);
                                                //tiposorteo ? setTabla1(newValue) : setTabla2(newValue);
                                                //console.log("Valor creado", newValue.slice(operation.fromRowIndex, operation.toRowIndex));
                                                ///Saber si manda el axios
                                            }

                                            if (operation.type === 'UPDATE') {
                                                //let testAcumn=AcumNumTabla(newValue);
                                                //onsole.log("testAcum",testAcumn)
                                                //console.log("Valor actualizado", newValue.slice(operation.fromRowIndex, operation.toRowIndex));
                                                //console.log("dtaUpdate", newValue)
                                                //console.log("#Actualizados", newValue.slice(operation.fromRowIndex, operation.toRowIndex).length);
                                                newValue.slice(operation.fromRowIndex, operation.toRowIndex).forEach(({ id }) => {
                                                    if (!createdRowIds.has(id) && !deletedRowIds.has(id)) {
                                                        updatedRowIds.add(id)
                                                        deletedRowIds.delete(id)
                                                    }
                                                });
                                                //console.log("testx",testMaxC)
                                                /* if (testMaxC != 0) {
                                                    let sum = CheckCantNum(newValue, newValue[operation.fromRowIndex].numero, tiposorteo);
                                                    //console.log("SumaTitak",sum);
                                                    if (newValue[operation.fromRowIndex].numero != null && newValue[operation.fromRowIndex].numero != '' && newValue[operation.fromRowIndex].cantidad != null && newValue[operation.fromRowIndex].cantidad != '') {
                                                        //console.log("aaaa", ref.current?.activeCell)
                                                        $("#backdrop").show();
                                                        let res=await CheckInputCapture(newValue[operation.fromRowIndex].numero, newValue[operation.fromRowIndex].cantidad);
                                                        console.log("llamada",res.status);
                                                        if (res.status==400) {
                                                            //alert('pendejo')
                                                            
                                                            newValue[operation.fromRowIndex].cantidad = '';
                                                            await $("#backdrop").hide();
                                                            await window.Swal.fire({
                                                                icon: 'error',
                                                                title: 'Error',
                                                                text: "Número saturado",
                                                            });
                                                            
                                                        }else{
                                                            $("#backdrop").hide();
                                                        }
                                                        //$("#backdrop").hide();
                                                    }
                                                } */

                                            }

                                            if (operation.type === 'DELETE') {
                                                //console.log("Valor eleminado", newValue.slice(operation.fromRowIndex, operation.toRowIndex));
                                                let keptRows = 0;

                                                var Array = tiposorteo ? Tabla1 : Tabla2;

                                                Array.slice(operation.fromRowIndex, operation.toRowIndex).forEach(({ id }, i) => {
                                                    updatedRowIds.delete(id)
                                                    if (createdRowIds.has(id)) {
                                                        createdRowIds.delete(id)
                                                        deletedRowIds.add(id)
                                                    } else {
                                                        deletedRowIds.add(id)
                                                    }
                                                });
                                            }
                                            //let CantidaMax = parseFloat(inputElementCmax.current.value);
                                            //console.log("textmemo",testMaxC);


                                        }
                                        //console.log("tabale", Tabla1)

                                        //let newValue2=[...newValue];
                                        //newValue2[0].cantidad=200;
                                        //tiposorteo ? setTabla1(newValue2) : setTabla2(newValue2);
                                        //setHasErrorCaptura(VerifyCantidad())
                                        //console.log("malditaval", VerifyCantidad(newValue));
                                        //setHasErrorCaptura(VerifyCantidad(newValue));//Comprobacion para ver si las cantidades son mayores a 0
                                        //newValue = AcumNumTabla(newValue);
                                        tiposorteo ? setTabla1(newValue) : setTabla2(newValue);
                                    }}
                                    columns={columns}
                                    stickyRightColumn={{
                                        component: ({ deleteRow }) => (
                                            <button className='btn btn-sm' onClick={() => {
                                                window.Swal.fire({
                                                    title: '¿Está seguro de eliminar el registro seleccionado?',
                                                    icon: 'warning',
                                                    showCancelButton: true,
                                                    confirmButtonColor: '#3085d6',
                                                    cancelButtonColor: '#d33',
                                                    confirmButtonText: 'Aceptar',
                                                    cancelButtonText: 'Cancelar',
                                                }).then(async (result) => {
                                                    if (result.isConfirmed) {
                                                        deleteRow()
                                                    }
                                                });
                                            }}>❌</button>
                                        ),
                                    }}
                                    disableContextMenu
                                    disableExpandSelection
                                    rowClassName={({ rowData }) => {
                                        //console.log(rowData);
                                        //console.log("MaxC",cMaxima);
                                        if (CheckRow(rowData.cantidad)) {
                                            return 'row-deleted'
                                        }
                                    }}

                                //rowClassName={({ rowIndex }) => CheckRow(rowIndex) ? 'row-deleted' : null }
                                //disableExpandSelection
                                />
                                {/* <div><p className="text-dange"></p></div> */}
                                {/*  <button onClick={() => { console.log('statet1', Tabla1), console.log('state2', Tabla2), console.log('Nuevos', createdRowIds), console.log('actualizados', updatedRowIds), console.log('eleminados', deletedRowIds) }}>test estate</button> */}
                                <div className='row py-3'>
                                    <div className='col-6'>
                                        Total {tiposorteo ? 'primer lugar' : 'segundo lugar'}: <br />
                                        <strong> ${tiposorteo ? totalSum.Totaltabla1 : totalSum.Totaltabla2}</strong>
                                    </div>
                                    <div className='col-6 text-right'>
                                        Total capturado: <br />
                                        <strong> ${totalSum.TotalCompleto}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Security>
    )
}
